import React from 'react';
import { useField } from 'formik';
import { TextField } from '@material-ui/core';

function MySelect(props) {

  let [field, meta] = useField(props);

  return (
    <TextField
      select
      {...props}
      {...field}
      error={!!meta.error && meta.touched}
      helperText={meta.touched && meta.error}
      fullWidth
      variant="outlined"
    >
      {props.children}
    </TextField>
  );
}

export default MySelect;